/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
export const receiverIconCss = css`
  width: 21px;
  height: 21px;
`;

export const selectedCss = css`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 120%;
  margin-right: 0.5rem;
  color: #ffffff;
  display: flex;
  align-items: center;
`;

export const selectedToCss = css`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  text-align: right;
  color: #f1f3f3;
`;
export const inputToCss = css`
  ${selectedToCss};
  font-size: 16px;
  margin-right: 0.5rem;
`;

export const sendSectionStyle = css`
  min-height: 54px;
  background: #172a2d;
  border-radius: 14px;
  margin-bottom: 7px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 14px 10px;
`;

export const sendToSwitch = css`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: flex-end;
  text-align: right;
  color: #808b8b !important;
  border-radius: 14px;
  padding: 0;
  border: 0;
  background: transparent;
`;

export const pasteButtonStyle = css`
  background: transparent;
  border: 0;
  color: #38da7c;
  display: flex;
  font-weight: 400;
  font-size: 14px;
  align-items: center;
`;

export const addressInputStyle = css`
  background: transparent;
  border: 0;
  flex-grow: 1;
  color: #f1f3f3;
  line-height: 130%;
  font-size: 14px;
  font-weight: 500;
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  &::placeholder {
    color: #4d676a;
  }
  &:focus {
    outline: none;
  }
`;
export const viewOnExplorerLinkStyle = css`
  margin-right: 1rem;
`;
